module.exports = __webpack_public_path__ + "img/person-img1.e9988182.png";